if (!customElements.get('speech-search-button')) {
  class SpeechSearchButton extends HTMLElement {
    /**
     * Runs on insertion rather than in the constructor, so the element still sets itself up
     * when a section is re-rendered in the theme editor and inserted after being created.
     */
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.form = this.closest('form');
      this.input = this.form ? this.form.querySelector('.js-search-input') : null;
      this.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

      if (!this.SpeechRecognition || !this.input) {
        this.markUnsupported();
        return;
      }

      this.setAttribute('role', 'button');
      this.classList.remove('hidden');
      this.addEventListener('click', this.handleActivate.bind(this));
      this.addEventListener('keydown', this.handleKeydown.bind(this));
    }

    disconnectedCallback() {
      this.stopListening();
    }

    /**
     * Hides the mic and lets the search field reclaim its padding.
     */
    markUnsupported() {
      const searchForm = this.closest('search-form');
      if (searchForm) searchForm.classList.add('speech-search--failed');
      this.remove();
    }

    /**
     * Handles Enter/Space on the button, which is not a native <button>.
     * @param {object} evt - Event object.
     */
    handleKeydown(evt) {
      if (evt.key !== 'Enter' && evt.key !== ' ') return;
      evt.preventDefault();
      this.handleActivate();
    }

    handleActivate() {
      if (this.recognition) {
        this.stopListening();
      } else {
        this.startListening();
      }
    }

    startListening() {
      this.recognition = new this.SpeechRecognition();
      this.recognition.lang = document.documentElement.lang || 'en-GB';
      this.recognition.interimResults = true;
      this.recognition.continuous = false;

      this.recognition.addEventListener('result', this.handleResult.bind(this));
      this.recognition.addEventListener('error', this.stopListening.bind(this));
      this.recognition.addEventListener('end', this.stopListening.bind(this));

      try {
        this.recognition.start();
      } catch (e) {
        this.stopListening();
        return;
      }

      this.classList.add('search__speech-listening');
      this.setAttribute('aria-pressed', 'true');
    }

    stopListening() {
      if (this.recognition) {
        this.recognition.abort();
        this.recognition = null;
      }
      this.classList.remove('search__speech-listening');
      this.setAttribute('aria-pressed', 'false');
    }

    /**
     * Writes the transcript into the search field, submitting once the result is final.
     * @param {object} evt - SpeechRecognitionEvent object.
     */
    handleResult(evt) {
      const result = evt.results[evt.results.length - 1];
      const transcript = result[0].transcript.trim();
      if (!transcript) return;

      this.input.value = transcript;
      this.input.dispatchEvent(new Event('input', { bubbles: true }));

      if (result.isFinal) {
        this.stopListening();
        this.form.submit();
      }
    }
  }

  customElements.define('speech-search-button', SpeechSearchButton);
}
